import cn from 'classnames';
import { useContext } from 'react';

import Heading from 'components/common/Heading';
import Text from 'components/common/Text';
import Chat from 'components/icons/illustrative/Chat';
import Enjoy from 'components/icons/illustrative/Enjoy';
import Gift from 'components/icons/illustrative/Gift';
import InviteForm from 'components/signUpFunnel/thankYou/InviteForm';
import { BrandContext } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';
import { TEMPO } from 'lib/constants';
import { ICON_SIZES } from 'lib/constants/iconSizes';
import style from 'styles/components/signUpFunnel/thankYou/InviteFriendsInstructions';

const InviteFriendsInstructions = ({
  giveToFriendText,
  isSmartphoneScreenSize = false,
  referralAmountFormatted = '$35',
}) => {
  const { brand } = useContext(BrandContext);
  const isTempo = useBrand(TEMPO);

  return (
    <>
      <div className="mt-48">
        <div className={style.smartphoneHorizontalContainer}>
          <div className={cn(style.smartphoneHorizontalLine, 'mx-auto w-16')} />
          <div>
            <Text className={style.smartphoneHorizontalText} brandStylesOverrides="h7">
              Or email an invitation
            </Text>
          </div>
          <div className={cn(style.smartphoneHorizontalLine, 'mx-auto w-16')} />
        </div>
        <InviteForm brand={brand} isSmartphoneScreenSize={isSmartphoneScreenSize} />
        <Heading brandStylesOverrides="h3" className="mx-auto mt-6">
          Invite friends, get free food!
        </Heading>
        <div>
          <div className="mx-auto mt-5 flex">
            <Gift className="mt-4" svgSize={ICON_SIZES.LG} />
            <div className={style.textContainer}>
              <Text
                brandStylesOverrides="h5"
                className={cn(
                  { 'text-tempo-black-100': isTempo, 'text-green-110': !isTempo },
                  'mb-0'
                )}
              >
                Give the gift of food.
              </Text>
              <Text className="text-secondary">{giveToFriendText}</Text>
            </div>
          </div>
          <div className="mx-auto flex">
            <Enjoy className="mt-4" svgSize={ICON_SIZES.LG} />
            <div className={style.textContainer}>
              <Text
                brandStylesOverrides="h5"
                className={cn(
                  { 'text-tempo-black-100': isTempo, 'text-green-110': !isTempo },
                  'mb-0'
                )}
              >
                And get free food for you.
              </Text>
              <Text className="text-secondary">
                When a friend signs up, you get {referralAmountFormatted} in credit, too!
              </Text>
            </div>
          </div>
          <div className="mx-auto flex">
            <Chat className="mt-4" svgSize={ICON_SIZES.LG} />
            <div className={style.textContainer}>
              <Text
                brandStylesOverrides="h5"
                className={cn(
                  { 'text-tempo-black-100': isTempo, 'text-green-110': !isTempo },
                  'mb-0'
                )}
              >
                Join the cooking community.
              </Text>
              <Text className="text-secondary">
                Cooking is more fun with friends! Send pics of your meals to a friend or post ‘em to
                the gram and tag @realhomechef.
              </Text>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

InviteFriendsInstructions.propTypes = {
  giveToFriendText: PropTypes.string.isRequired,
  isSmartphoneScreenSize: PropTypes.bool,
  referralAmountFormatted: PropTypes.string.isRequired,
};

export default InviteFriendsInstructions;
